<template>
	<div>
		<transition name="slide">
			<UiBrackets v-if="!loading" :matches="matches"></UiBrackets>
		</transition>
		<transition name="slide">
			<div class="loading" v-if="loading">
				<QlashLoader></QlashLoader>
			</div>
		</transition>
	</div>
</template>
<script>
import UiBrackets from '../../../components/brackets/UiBrackets'
import QlashLoader from '../../../components/QlashLoader'
import { mapActions, mapGetters } from 'vuex'
export default {
	data () {
		return {
			loading: true,
      interval: null
		}
	},
	computed: {
		...mapGetters({
			tournament: 'tournament/tournament',
			matches: 'tournament/getMatches'
		})
	},
	methods: {
		...mapActions({
			getMatches: 'tournament/getMatches',
			getResults: 'tournament/getResults'
		}),
		async init () {
			await this.getResults(this.tournament.id)
			await this.getMatches(this.tournament.id)
			this.loading = false
		}
	},
	mounted () {
		this.init()
    this.interval = setInterval(async () => {
      await this.getResults(this.tournament.id)
      await this.getMatches(this.tournament.id)
    }, 50000)
	},
  beforeDestroy() {
    clearInterval(this.interval)
  },
  components: {
		QlashLoader,
    UiBrackets
		// UiBrackets
	}
}
</script>
<style scoped lang="scss">
.loading {
	margin: 50px 0;
  display: flex;
  justify-content: center;

}
.slide-enter-active, .slide-leave-active {
	transition: all .15s ease-in;
	top: -10px;
}

.slide-enter, .slide-leave-to {
	opacity: 0;
}

.slide-enter-to, .slide-leave {
	opacity: 1;
	top: 0;
}

</style>
